import React from 'react';
import { Divider } from 'semantic-ui-react'

const HomeAdmin1 = ({autorizacUA, styles, handleClickSel11, handleClickSel12, handleClickSel13, handleClickSel14, 
                    handleClickSel15, handleClickSel16, handleClickSel17, handleClickSel18, handleClickSel19, 
                    handleClickSel20, handleClickSel21, handleClickSel22, handleClickSel23, handleClickSel24, 
                    handleClickSel25, handleClickSel26, handleClickSel27, handleClickSel28, handleClickSel29, 
                    handleClickSel30, handleClickSel31,handleClickSel32}) => {
  const a3505 = autorizacUA.findIndex( autorizac => autorizac === "3505" );
  const a3510 = autorizacUA.findIndex( autorizac => autorizac === "3510" );
  const a3515 = autorizacUA.findIndex( autorizac => autorizac === "3515" );
  const a3520 = autorizacUA.findIndex( autorizac => autorizac === "3520" );
  const a3525 = autorizacUA.findIndex( autorizac => autorizac === "3525" );
  const a3530 = autorizacUA.findIndex( autorizac => autorizac === "3530" );
  const a3535 = autorizacUA.findIndex( autorizac => autorizac === "3535" );
  const a3540 = autorizacUA.findIndex( autorizac => autorizac === "3540" );
  const a3545 = autorizacUA.findIndex( autorizac => autorizac === "3545" );
  const a3550 = autorizacUA.findIndex( autorizac => autorizac === "3550" );
  const a3555 = autorizacUA.findIndex( autorizac => autorizac === "3555" );
  const a3560 = autorizacUA.findIndex( autorizac => autorizac === "3560" );
  const a3565 = autorizacUA.findIndex( autorizac => autorizac === "3565" );
  const a3570 = autorizacUA.findIndex( autorizac => autorizac === "3570" );
  const a3573 = autorizacUA.findIndex( autorizac => autorizac === "3573" );
  const a3575 = autorizacUA.findIndex( autorizac => autorizac === "3575" );
  const a3578 = autorizacUA.findIndex( autorizac => autorizac === "3578" );
  const a3580 = autorizacUA.findIndex( autorizac => autorizac === "3580" );
  const a3585 = autorizacUA.findIndex( autorizac => autorizac === "3585" );
  const a3590 = autorizacUA.findIndex( autorizac => autorizac === "3590" );
  const a3595 = autorizacUA.findIndex( autorizac => autorizac === "3595" );


  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        COMERCIAL
      </button>
      {/* {a3595!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel13}>
          <i className="large file alternate outline red icon"></i>
          Consultar precios
        </button>
      } */}
      {a3525!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel15}>
          <i className="large file alternate outline red icon"></i>
          Cotizaciones para clientes
        </button>
      }      
      {a3530!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel16}>
          <i className="large paper plane outline red icon"></i>
          Reportar envío de cotización
        </button>
      }
      {a3535!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel17}>
          <i className="large paper plane red icon"></i>
          Cotizaciones enviadas
        </button>
      }
      {/* <Divider inverted /> */}
      {a3540!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel18}>
          <i className="large video play red icon"></i>
          Iniciar Ejecución
        </button>
      }
      {a3545!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel19}>
          <i className="large pause circle red icon"></i>
          Finalizar Ejecución
        </button>
      }
      {a3550!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel22}>
          <i className="large comment alternate red icon"></i>
          Responder encuesta
        </button>
      }
      {a3555!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel20}>
          <i className="large file archive red icon"></i>
          Solicitudes de facturación
        </button>
      }     
      {a3555!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel30}>
          <i className="large file archive red icon"></i>
          Bitacora de facturación
        </button>
      }
      {a3578!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel32}>
          <i className="large file archive red icon"></i>
          Registrar pagos de clientes
        </button>
      }
      {a3578!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel14}>
          <i className="large file archive red icon"></i>
          Bitacora de recaudos
        </button>
      }
      {a3560!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel21}>
          <i className="large linkify red icon"></i>
          Consultar cadena de valor
        </button>
      }
      {localStorage.getItem('userLogin')==="slcm@slcm.com" &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel31}>
            <i className="large searchengin red icon"></i>
            Descargar archivo para indicadores
        </button>
      }
      {a3525!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel11}>
          <i className="large file alternate outline red icon"></i>
          Solicitud de traslado de productos
        </button>
      }
      {a3590!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel12}>
          <i className="large file alternate outline red icon"></i>
          Registrar traslado de productos
        </button>
      }
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        COMPRAS
      </button>

      {a3565!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel23}>
          <i className="large flag checkered red icon"></i>
          Solicitud de orden de compra
        </button>
      }
      {a3570!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel24}>
          <i className="large add to cart red icon"></i>
          Cotizaciones de proveedores
        </button>
      }
      {a3573!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel28}>
          <i className="large add to cart red icon"></i>
          Seleccionar proveedores
        </button>
      }
      {a3575!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel25}>
          <i className="large dollar sign red icon"></i>
          Ordenes de compra en proceso
        </button>
      }   
      {/* {a3578!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel29}>
          <i className="large dollar sign red icon"></i>
          Registrar pagos
        </button>
      }     */}
      {a3580!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel26}>
          <i className="large file alternate outline red icon"></i>
          Consultar histórico
        </button>
      }      
      {a3585!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel27}>
          <i className="large paper plane outline red icon"></i>
          Exportar a excel
        </button>
      }
    </div>
  )
};

export default HomeAdmin1
